<template>
  <div id="app">
    <div class="app-wrapper">
      <header-navigation class="header" />

      <div class="main-content">
        <router-view />
      </div>

      <footer-menu class="footer" />
    </div>
  </div>
</template>

<script>
import HeaderNavigation from "./design/HeaderNavigation";
import FooterMenu from "./design/FooterMenu";
import "normalize.css";

export default {
  components: {
    HeaderNavigation,
    FooterMenu,
  },
};
</script>

<style>
* {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

body {
  line-height: 1;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.app-wrapper {
  width: 100vw;
}
.main-content {
  width: 90vw;
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media screen and (max-width: 599px) {
  .main-content {
    width: 95vw;
    padding-top: 100px;
  }
}
@media screen and (min-width: 600px) and (max-width: 959px) {
}
@media screen and (min-width: 960px) {
}
</style>
